import { useLayoutEffect, useRef, type DependencyList } from 'react'
import type { BoggleStore } from '~/boggle/ui/state/Store'

/**
 * Runs `paint` on mount and whenever `store.subscribeTime` fires, without React
 * re-renders. Pass `store` as null/undefined to paint only when `deps` change.
 */
export function useBoggleImperativeTimePaint(
  paint: () => void,
  deps: DependencyList,
  store?: BoggleStore | null,
) {
  const paintRef = useRef(paint)
  paintRef.current = paint

  useLayoutEffect(() => {
    const run = () => {
      paintRef.current()
    }
    run()
    if (!store) {
      return
    }
    return store.subscribeTime(run)
  }, [store, ...deps])
}
